<template>
	<div id="login">
		<form v-on:submit.prevent="loginUser">
			<fieldset>
				<legend><i class="fad fa-sign-in"></i> Login</legend>
				<div class="label-field">
					<label for="email">
						<i class="fad fa-at"></i> Email
					</label>
					<input id="email" v-model.trim="email" type="email" minlength="9" autocomplete="username" required />
				</div>
				<div class="label-field">
					<label for="password">
						<i class="fad fa-key"></i> Password
					</label>
					<input id="password" v-model="password" type="password" minlength="6" autocomplete="current-password" required />
				</div>
			</fieldset>
			<fieldset>
				<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
				<div v-else class="label-field">
					<button>
						<span>SUBMIT</span> <i class="fad fa-angle-right fa-fw"></i>
					</button>
				</div>
			</fieldset>
		</form>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false,
			email: '',
			password: ''
		}
	},
	methods: {
		async loginUser(){
			this.isLoading = true

			var loginData = {
				email: this.email,
				password: this.password
			}

			try {
				await this.$store.dispatch('userLogin',loginData).then(response => {
					if(response === 'success'){
						this.$router.replace('/admin')
					} else {
						alert(response.message)
					}
				})
			}
			catch(err) {
				alert(err)
			} 
			finally {
				this.isLoading = false
			}

		}
	}
}
</script>
<style scoped>
#login  {
	display: grid;
	height: 100vh;
	place-items: center;
}

	#login form {
		width: 330px;
	}
</style>